module.exports = __webpack_public_path__ + "img/pencil.5c1f3e46.png";